import React, { FC } from 'react'
// PRO-130: deep antd/es/* subpaths, NOT the `antd` root barrel (this wrapper is
// on the boot-static graph via BreadCrumb — see src/antd/Empty.tsx).
import AntdDropdown from 'antd/es/dropdown'
import type { DropdownProps } from 'antd/es/dropdown'
import DropdownButton from 'antd/es/dropdown/dropdown-button'

/**
 * The ANTD half of the `src/antd/Dropdown` seam — the previous
 * `src/antd/Dropdown.tsx`, MOVED, not rewritten. `./index.tsx` is the
 * dispatcher.
 *
 * Never edit this file to fix something you saw with the design toggle ON: it
 * is what every customer renders today, and `../__tests__/
 * dropdown-seam-parity.test.tsx` holds it node for node. The shadcn rendering
 * lives in `./Dropdown.shadcn`.
 *
 * The `getPopupContainer` default below is the reason this seam SHADOWS antd
 * rather than re-exporting it, and `./Dropdown.shadcn` keeps it.
 */
const Dropdown: FC<DropdownProps> & {
  Button: typeof DropdownButton
} = ({ children, ...props }) => (
  <AntdDropdown
    getPopupContainer={(trigger) => trigger.parentElement!}
    {...props}
  >
    {children}
  </AntdDropdown>
)

Dropdown.Button = AntdDropdown.Button

export { Dropdown }
